import { render, staticRenderFns } from "./phoneExtGroupForm.vue?vue&type=template&id=31939600&"
import script from "./phoneExtGroupForm.vue?vue&type=script&lang=js&"
export * from "./phoneExtGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports